const getDefaultState = () => {
  return {
    dates: null,
    beginDate: null,
    untilDate: null,
    currentDateRange: null,
    marketingTabs: 1,
    offersTabs: 0,
    offersPage: 1,
    loyaltyTabs: 0,
    loyaltyPage: 1,
    customersTabs: 0,
    customersPage: 1,
    customersSearch: null,
    customersFilters: null,
    createOfferStep: 0,
    offerDetailsStep: 0,
    offer: {
      purchase_products: [],
      free_products: [],
      customers: [],
      groups: [],
      redeem_method: 'general_code',
      reward_type: 'discount_percentage',
      usage_limit_type: 'one_each'
    },
    blasts: [],
    marketingSettings: {},
    loyaltySettings: {},
    member: {},
    summary: {
      totalCustomers: 0,
      totalLoyaltyMembers: 0,
    }
  }
}
const state = getDefaultState()

export default {
  namespaced: true,
  state,
  mutations: {
    resetMarketing (state) {
      Object.assign(state, getDefaultState())
    },
    resetMarketingOffer (state) {
      state.offer = {
        purchase_products: [],
        free_products: [],
        customers: [],
        groups: [],
        redeem_method: 'general_code',
        reward_type: 'discount_percentage',
        usage_limit_type: 'one_each'
      }
      state.blasts = []
      state.createOfferStep = 0
      state.offerDetailsStep = 0
    },
    resetLoyaltySettings (state) {
      state.loyaltySettings = {}
    },
    setMarketingTabs (state, tab) {
      state.marketingTabs = tab
    },
    setOffersTabs (state, tab) {
      state.offersTabs = tab
    },
    setOffersPage (state, tab) {
      state.offersPage = tab
    },
    setLoyaltyTabs (state, tab) {
      state.loyaltyTabs = tab
    },
    setLoyaltyPage (state, tab) {
      state.loyaltyPage = tab
    },
    setCustomersTabs (state, tab) {
      state.customersTabs = tab
    },
    setCustomersPage (state, tab) {
      state.customersPage = tab
    },
    setCustomersSearch (state, tab) {
      state.customersSearch = tab
    },
    setCustomersFilters (state, tab) {
      state.customersFilters = tab
    },
    setCreateOfferStep (state, step) {
      state.createOfferStep = step
    },
    setOfferDetailsStep (state, step) {
      state.offerDetailsStep = step
    },
    setOffer (state, data) {
      state.offer = data
    },
    setBlasts (state, data) {
      state.blasts = data
    },
    setMarketingSettings (state, data) {
      state.marketingSettings = data
    },
    setLoyaltySettings (state, data) {
      state.loyaltySettings = data
    },
    setDates(state, data) {
      state.dates = data
    },
    setBeginDate(state, data) {
      state.beginDate = data
    },
    setUntilDate(state, data) {
      state.untilDate = data
    },
    setCurrentDateRange(state, data) {
      state.currentDateRange = data
    },
    setMember(state, data) {
      state.member = data
    },
    setTotalCustomerSummary(state, data) {
      state.summary.totalCustomers = data
    },
    setTotalLoyaltyMemberSummary(state, data) {
      state.summary.totalLoyaltyMembers = data
    }
  },
  getters: {
    getMarketingTabs (state) {
      return state.marketingTabs
    },
    getOffersTabs (state) {
      return state.offersTabs
    },
    getOffersPage (state) {
      return state.offersPage
    },
    getLoyaltyTabs (state) {
      return state.loyaltyTabs
    },
    getLoyaltyPage (state) {
      return state.loyaltyPage
    },
    getCustomersTabs (state) {
      return state.customersTabs
    },
    getCustomersPage (state) {
      return state.customersPage
    },
    getCustomersSearch (state) {
      return state.customersSearch
    },
    getCustomersFilters (state) {
      return state.customersFilters
    },
    getCreateOfferStep (state) {
      return state.createOfferStep
    },
    getOfferDetailsStep (state) {
      return state.offerDetailsStep
    },
    getOffer (state) {
      return state.offer
    },
    getBlasts (state) {
      return state.blasts
    },
    getMarketingSettings (state) {
      return state.marketingSettings
    },
    getLoyaltySettings (state) {
      return state.loyaltySettings
    },
    getDates(state) {
      return state.dates
    },
    getBeginDate(state) {
      return state.beginDate
    },
    getUntilDate(state) {
      return state.untilDate
    },
    getCurrentDateRange(state) {
      return state.currentDateRange
    },
    getMember(state) {
      return state.member
    },
    getSummary(state) {
      return state.summary
    }
  }
}